import React from "react"
import { useSelector } from "react-redux"

import K10Logo from "../assets/logo_10k.svg"
import K10MedicalLogo from "../assets/logo_10km.svg"
import { useReduxState } from "../hooks/use_redux_state"


const AppLogo = ({...props}) => {

  const userCohort = useSelector(state => state.auth?.user.cohort)
  const [signupCohort] = useReduxState({ key: "signupCohort" })
  const cohort = signupCohort || userCohort;
  
  const logo = (() => {
    return K10Logo
  })()

  return <>
    {logo && <img
      src={logo}
      alt="logo"
      {...props}
    />}
  </>
}

AppLogo.propTypes = {}

AppLogo.defaultProps = {}

export default AppLogo
